import React from 'react';
import PropTypes from 'prop-types';

const Scan = ({color = 'currentColor', ...props}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.33327 2H3.77772C2.79588 2 1.99994 2.79594 1.99994 3.77778V7.33333M7.33327 18H3.77772C2.79588 18 1.99994 17.2041 1.99994 16.2222V12.6667M12.6666 2H16.2222C17.204 2 17.9999 2.79594 17.9999 3.77778V7.33333M17.9999 12.6667V16.2222C17.9999 17.2041 17.204 18 16.2222 18H12.6666M1.99994 10.0002H17.9999"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>

);

Scan.propTypes = {
  color: PropTypes.string,
};

export default Scan;
